import axios from "axios";

const state = {
    allusers: []
};

const getters = {
    AllUsers: (state) => state.allUsers
};

const actions = {

    async GetListUsers({ commit }, params = {}) {
        const page = params.page !== undefined ? params.page : '';
        const search = params.search !== undefined ? params.search : '';
        
        let url = `${process.env.VUE_APP_APIURL}users`;
        let queryParams = [];
        
        if (page !== '') queryParams.push(`page=${page}`);
        if (search !== '') queryParams.push(`search=${encodeURIComponent(search)}`);
        
        if (queryParams.length > 0) {
            url += '?' + queryParams.join('&');
        }
        
        await axios.get(url)
          .then((response) => {
              commit("setAllUsers", response.data);
          })
          .catch((error) => {
              console.log(error);
          });
    },  

    async UpdateUser({ commit }, body) {
        return await axios.post(`${process.env.VUE_APP_APIURL}users/${body.usr_id}`, body)
          .then(() => {
            return true;
          })
          .catch((error) => {
            console.log(error);
            return false;
          });
    }
}

const mutations = {
    setAllUsers(state, users) {
        state.allUsers = users;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};